import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { requestSelectors } from 'src/store/requests/selectors';
import { getCurrentSpinner, getSpinnerMode } from 'src/store/spinner/selectors';
import { spinnerMode } from 'src/store/spinner/reducer';

export const useGetSpinnerSvg = () => {
  const spinnerSvgCurrentData = useSelector(requestSelectors.spinner.getSpinnerViewData);
  const spinnerSvgCurrentDataAlt = useSelector(requestSelectors.spinner.getSpinnerViewDataAlt);
  const currentSpinnerMode = useSelector(getSpinnerMode);
  const currentSpinner = useSelector(getCurrentSpinner);

  const spinnersConfig = useMemo(() => {
    if (spinnerSvgCurrentData && currentSpinner) {
      return (currentSpinnerMode === spinnerMode.day ? spinnerSvgCurrentData : (spinnerSvgCurrentDataAlt?.[currentSpinner.name]?.[currentSpinner['name-id']] ? spinnerSvgCurrentDataAlt : spinnerSvgCurrentData));
    }
    return undefined;
  },
  [currentSpinnerMode, spinnerSvgCurrentData, spinnerSvgCurrentDataAlt, currentSpinner]);

  const displayedSvgData = useMemo(() => {
    return currentSpinner ? spinnersConfig?.[currentSpinner.name][currentSpinner['name-id']]?.additional_data?.spinner_svg : undefined;
  }, [currentSpinner, spinnersConfig]);

  const isEntityHasSpinner = useCallback((name: string, nameId: string): boolean => {
    return !!spinnersConfig?.[name][nameId];
  }, [spinnersConfig]);

  return {
    currentSpinner,
    displayedSvgData,
    currentSpinnerMode,
    spinnersConfig,
    spinnerSvgCurrentData,
    spinnerSvgCurrentDataAlt,
    isEntityHasSpinner,
  };
};
